<template>
  <div>
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_pdProcessDictStep') || '工序'">
            <el-input v-model="formData.v_pdProcessDictStep" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_techName') || '工艺'">
            <el-input v-model="formData.techName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$l('form_label_techDesc') || '工艺要求'">
            <el-input
              v-model.trim="formData.techDesc"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_techChargeUnit') || '计价单位'">
            <dict-select
              v-model="formData.techChargeUnit"
              url="/master/common/dict/biz"
              :body="techChargeUnitParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_unitPrice') || '单价'">
            <el-input-number
              v-model="formData.unitPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="99999.9999"
              :step="1"
              :precision="4"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_qty') || '数量'" prop="qty">
            <el-input-number
              v-model="formData.qty"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="99999.9999"
              :step="1"
              :precision="4"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_subPrice') || '小计'">
            <el-input v-model="v_subPrice" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { multiplyRound, format } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  props: {
    pdCostsOrderGoodsSpecProcessCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      techChargeUnitParams: { dictType: 'techChargeUnit' },
      rules: {
        qty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('INDEX.tips_input_cannot_be_zero')))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    subPrice() {
      const { qty, unitPrice } = this.formData
      return multiplyRound(qty, unitPrice)
    },
    v_subPrice() {
      return format(this.subPrice)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.pdCostsOrderGoodsSpecProcessCode) return
      const res = await this.$api
        .pdCostsOrderGoodsSpecProcessDetailApi({
          pdCostsOrderGoodsSpecProcessCode: this
            .pdCostsOrderGoodsSpecProcessCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      const res = await this.$api
        .pdCostsOrderGoodsSpecProcessUpdateApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
